import { jsx as _jsx } from "react/jsx-runtime";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
export function LayoutLoadingIndicator() {
    return (_jsx(Backdrop, { open: true, children: _jsx(CircularProgress, { color: "primary" }) }));
}
//# sourceMappingURL=LayoutLoadingIndicator.js.map